export default {
  components: {
    Dynamic: () => import('@/Pages/Asset/Contract/Components/Dynamic'),
    PageHeading: () => import('@/Pages/Asset/Contract/Components/PageHeading'),
    SubHeading: () => import('@/Pages/Asset/Contract/Components/SubHeading'),
    ArticleHeading: () => import('@/Pages/Asset/Contract/Components/ArticleHeading'),
    SmallHeading: () => import('@/Pages/Asset/Contract/Components/SmallHeading'),
    Paragraph: () => import('@/Pages/Asset/Contract/Components/Paragraph'),
    List: () => import('@/Pages/Asset/Contract/Components/List'),
    ExpandableList: () => import('@/Pages/Asset/Contract/Components/ExpandableList'),
    SingleList: () => import('@/Pages/Asset/Contract/Components/List'),
    BulletList: () => import('@/Pages/Asset/Contract/Components/List'),
    Inline: () => import('@/Pages/Asset/Contract/Components/Inline/Inline'),
    Choice: () => import('@/Pages/Asset/Contract/Components/Choice'),
    Grid: () => import('@/Pages/Asset/Contract/Components/Grid/Grid'),
    ExpandableGrid: () => import('@/Pages/Asset/Contract/Components/ExpandableGrid'),
    Html: () => import('@/Pages/Asset/Contract/Components/Html'),
  },
};
